// extracted by mini-css-extract-plugin
export var changeIcon = "_65-4";
export var container = "_65-0";
export var divider = "_65-7";
export var externalLinkIcon = "_65-1";
export var green = "_65-5";
export var helpCircleIcon = "_65-3";
export var iconButton = "_65-2";
export var red = "_65-6";